<!-- This component acts as a input field where users can be selected 
    There will be an input section where you will type the user and it will filter out the users and give you the user details
    This will be a flexible component and will return you user details everytime a user selected
    
    !!!!  UsersPicker is a bit different on pha-front compared to ignis-front because of version difference of Primevue and its component AutoComplete !!!!

    !!!!  Note:--  Please note that at the moment, the filter is working on the basis of email, please make sure to update it to name wise when api supports it later !!!!!
    !!!! on pha-front as well as ams-front
-->

<template>
    <div class="p-fluid">
        <div v-if="label" class="mb-2">
            <label :for="label">{{ props.label }}:</label>
        </div>
        <AutoComplete v-model="selectedUser" :id="label" :suggestions="users" field="fullname" :loading="loading" placeholder="Start typing user's email..." dropdown @item-select="userSelected" @complete="filterUsers" class="mb-1">
            <template #item="slotProps">
                <div>{{ slotProps.item.fullname }}</div>
            </template>
        </AutoComplete>
    </div>
</template>

<script setup>
import { ref, onMounted, watch, defineEmits, defineProps } from 'vue';

import useUserComposable from '@/composables/UserComposable';
const emit = defineEmits(['update:modelValue', 'user-selected']);

// Both props are not mandatory
const props = defineProps({
    label: String,
    modelValue: Number,
});

// Store states
const { users, getAllUsers } = useUserComposable();

// Component states
const loading = ref(false);
const selectedUser = ref(null);

watch(
    () => props.modelValue,
    () => {
        if (!props.modelValue) {
            selectedUser.value = null;
        }
    }
);

onMounted(() => {
    // Initially it will load 10 users by default params
    loadUsers();
});

const loadUsers = async (params = null) => {
    loading.value = true;
    await getAllUsers(params);
    loading.value = false;
};

const userSelected = () => {
    // Emit out event of selected user details
    emit('user-selected', selectedUser.value);
    // Emit out modelvalue just for id
    emit('update:modelValue', selectedUser.value?.id);
};
const filterUsers = async (event) => {
    // Filter string will be on query so use that in params.name to filter users
    await loadUsers({ email: event.query, page_size: 10, page: 0 });
};
</script>
